import Reveal from "./Reveal";
import { professional } from "@/config/professional";

export default function About() {
  return (
    <section id="sobre" className="relative overflow-hidden bg-background-50 py-16 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
          {/* Image */}
          <Reveal className="order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -left-4 -top-4 h-full w-full rounded-lg border border-primary-600/15" />
              <div className="relative overflow-hidden rounded-lg">
                <img
                  src={professional.aboutImage}
                  alt="Tatiana Andrade, Enfermeira Estomaterapeuta"
                  className="h-[420px] w-full object-cover object-top md:h-[520px]"
                />
              </div>
              <div className="absolute -bottom-6 -right-4 rounded-lg bg-accent-400 px-6 py-5 text-primary-950 shadow-none md:-right-6">
                <p className="font-heading text-3xl font-semibold leading-none">
                  +6 anos
                </p>
                <p className="mt-1 text-xs font-medium tracking-wide">
                  dedicados ao cuidado.
                </p>
              </div>
            </div>
          </Reveal>

          {/* Copy */}
          <div className="order-1 lg:order-2">
            <Reveal>
              <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary-600">
                Sobre
              </p>
              <h2 className="mt-4 font-heading text-4xl font-semibold leading-[1.1] tracking-tight text-foreground-950 md:text-5xl">
                Cuidar sempre foi mais do que uma profissão.
              </h2>
            </Reveal>

            <Reveal delay={80}>
              <div className="mt-7 space-y-5 text-base leading-relaxed text-foreground-600 md:text-[1.05rem]">
                <p>
                  Tatiana Andrade é Enfermeira Estomaterapeuta, especialista em
                  Laserterapia e possui mais de seis anos de experiência na área
                  da saúde.
                </p>
                <p>
                  Também atua como docente, preceptora e realiza atendimento
                  Home Care, unindo conhecimento, tecnologia e acolhimento no
                  cuidado com cada paciente.
                </p>
              </div>
            </Reveal>

            <Reveal delay={140}>
              <div className="mt-8 flex flex-wrap gap-3">
                {[
                  "Enfermeira",
                  "Estomaterapeuta — UECE",
                  "Especialista em Laser",
                  "Docente",
                  "Preceptora",
                  "Home Care",
                ].map((tag) => (
                  <span
                    key={tag}
                    className="whitespace-nowrap rounded-full border border-secondary-300 bg-secondary-100/60 px-4 py-2 text-sm font-medium text-secondary-900"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}